import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { EncryptDecryptService } from "./encrypt-decrypt.service";
import { Observable } from "rxjs";
import { ConfigurationService } from "../../services";

@Injectable()
export class EncryptDecryptAuthInterceptor implements HttpInterceptor {
  ExcludeURLList = [];
  apiBaseUrl: string;
  constructor(private encryptDecryptService: EncryptDecryptService, private configurations: ConfigurationService) {
    this.apiBaseUrl = `${this.configurations.baseUrl}/api/`;
    this.ExcludeURLList = ["/api/SepidzUserInfo/GetSepidzUserCode"];
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let exludeFound = this.ExcludeURLList.filter((element) => {
      return req.url.includes(element);
    });
    if (exludeFound && exludeFound["length"] > 0) {
      if (req.method == "GET") {
        const temp = req.url.replace(this.configurations.baseUrl, "");
        if (temp.indexOf("/") > 0) {
          console.log(req.url);
        }
        if (req.url.indexOf("?") > 0) {
          let encriptURL =
            req.url.substr(0, req.url.indexOf("?") + 1) +
            this.encryptDecryptService.encryptUsingAES256(req.url.substr(req.url.indexOf("?") + 1, req.url.length));
          const cloneReq = req.clone({
            url: encriptURL,
          });
          return next.handle(cloneReq);
        }
        return next.handle(req);
      } else if (req.method == "POST" || req.method == "PUT") {
        if (req.body || req.body.length > 0) {
          const cloneReq = req.clone({
            body: this.encryptDecryptService.encryptUsingAES256(req.body),
          });
          return next.handle(cloneReq);
        }
        return next.handle(req);
      }
    }
    return next.handle(req);
  }
}
